/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { InputFile, SelectCustom } from '@/components';
import { Form, FormGroup } from 'reactstrap';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import Section from '@/model/Section';
import { SectorRegisterToDropDownScreen } from '../../../SectorRegisterToDropDownScreen/screens';
import { FormInputName, NameFiles } from '../../types';

interface StateProps {
  sections: Section[];
  formData: FormData;
  formErrors: FormErrors;
  formNameFiles: NameFiles;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onChangeFormFileInput: (inputName: string) => (file: File | undefined) => void;
  onGetAllSections: () => void;
}

type Props = StateProps & DispatchProps;

export const SectorProductConfigSectorContent: React.FC<Props> = ({
  sections,
  formData,
  formErrors,
  onChangeFormInput,
  onChangeFormFileInput,
  formNameFiles,
  onGetAllSections,
}) => {
  const sectorSelected = {
    id: undefined,
    name: undefined,
  };
  const sectorActions = {
    onGetAllSector: onGetAllSections,
  };
  return (
    <Fragment>
      <Form
        noValidate={true}
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <FormGroup className="mb-2">
          <SelectCustom
            name="section"
            label="Nome do setor"
            placeholder="Digite ou selecione o nome do setor"
            value={formData[FormInputName.section]}
            onChange={e => onChangeFormInput(FormInputName.section)(e?.value as string)}
            error={formErrors.section && formErrors.section[0]}
            options={sections.map(sector => ({
              value: sector.id,
              label: sector.name,
            }))}
          />
          <SectorRegisterToDropDownScreen
            sectorStates={sectorSelected}
            sectorActions={sectorActions}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <InputFile
            name="imageBase64Sector"
            label="Imagem do setor (opcional)"
            fileName={formNameFiles?.imageBase64Sector}
            onChange={e =>
              onChangeFormFileInput(FormInputName.imageBase64Sector)(
                (e.target as HTMLInputElement)?.files?.[0],
              )
            }
            error={formErrors.imageBase64Sector && formErrors.imageBase64Sector[0]}
          />
        </FormGroup>
      </Form>
    </Fragment>
  );
};
